module.exports = "./img/aec3e3e6eb401975002c830e5c16b3ee.png";